import React from 'react'
import Header from '../Components/Header'
import useUser from '../hooks/useUser'
import LocationSidebar from '../Components/LocationSidebar'
import Login from '../Components/Login/Login'
import { useNavigate, useParams } from 'react-router-dom'
import Report from '../Components/WorkOrder/Report'

function ReportPage(){
     
    const {id} = useParams();
    const {user} = useUser();           
    
    const navigate = useNavigate();
    
    if(!user) {
        navigate("/login")        
    }
        
    return (      
        <div>
            <Header routing={"/report/addr_seq/:id"}></Header>    
            <div className='flex'>
                <LocationSidebar routingPage="/report/addr_seq"/> 
                <Report addrSeq={id}/>
            </div>              
        </div>          
    )
}

export default ReportPage